{
    "PageTitle_auth": "Authentification",
    "NAME": "Router",
    "PageTitle_presence": "Présence",
    "PageTitle_changePassword": "Changer le mot de passe",
    "PageTitle_forgotPassword": "Mot de passe oublié",
    "PageTitle_changeLanguage": "Changer de langue",
    "PageTitle_resetPassword": "Réinitialiser le mot de passe",
    "PageTitle_termsAndConditions": "Termes et conditions",
    "PageTitle_cookiePolicy": "Politique relative aux cookies",
    "PageTitle_privacyPolicy": "politique de confidentialité",
    "PageTitle_mfa": "Authentification multifacteur",
    "PageTitle_teamsAuth": "Authentification des équipes",
    "PageTitle_insights": "Connaissances",
    "PageTitle_crmIntegration": "Intégration CRM",
    "PageTitle_changeUserAgent": "Changer l'agent utilisateur",
    "PageTitle_clientConfiguration": "Configuration du client",
    "PageTitle_CRMConfiguration": "Configuration CRM",
    "PageTitle_adminControl": "Contrôles d'administration",
    "PageTitle_admin": "Administration",
    "PageTitle_cme": "CME",
    "PageTitle_status": "État du serveur d'applications",
    "PageTitle_licences": "Licences",
    "PageTitle_licenceManagement": "Gestion des licences",
    "PageTitle_telsys": "Serveurs de téléphonie",
    "PageTitle_users": "Utilisateurs de l'application",
    "PageTitle_partitions": "Cloisons",
    "PageTitle_device": "Appareils",
    "PageTitle_agent": "Agents",
    "PageTitle_code": "Codes",
    "PageTitle_auditTrail": "Piste d'audit",
    "PageTitle_logManagement": "Gestion des journaux",
    "PageTitle_loggingSettings": "Paramètres de journalisation",
    "PageTitle_telModuleStatus": "État du module téléphonique",
    "PageTitle_recording": "Enregistrement",
    "PageTitle_messages": "Messages",
    "PageTitle_database": "Base de données",
    "PageTitle_directory": "Annuaire",
    "PageTitle_cxScore": "Score CX",
    "PageTitle_cxScore-cx-score": "Score CX",
    "PageTitle_cxScore-overview": "Score CX",
    "PageTitle_cxScore-calls": "Score CX",
    "PageTitle_cxiDashboard": "Tableau de bord CXI"
}